export default "__VITE_ASSET__C5v0Ac7M__"